// extracted by mini-css-extract-plugin
module.exports = {"Container":"BulkEmailUpdate_Container__1nlUm"};